import axiosInstance from '../axiosInterceptor/axiosInstance'

const getPlayerStats = async ({ orgId, playerId }) => {
  const url = `v1/orgs/${orgId}/stats/players/${playerId}`
  return axiosInstance.get(url)
}

export default getPlayerStats
